import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBank: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"bank"} maskId="square-filled-radius-0-stroke-1-IconBank"><path fillRule="evenodd" clipRule="evenodd" d="M11.9984 1.42224L1.9984 7.21171V9.99999H3.9984V17H3.13802L1.80469 21H22.1921L20.8588 17H19.9984V9.99999H21.9984V7.21171L11.9984 1.42224ZM15.9984 9.99999H18.9984V17H15.9984V9.99999ZM7.9984 17H4.9984V9.99999H7.9984V17ZM8.9984 17V9.99999H14.9984V17H8.9984Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconBank;
